import { ErrorContentGenerator, ErrorContentMap, InvalidFieldMessages } from "./getAlertContent";
import { MfaFields, MfaStepProps } from "../../components/SmartErrorAlert";
import { AxiosResponse } from "axios";
import { MfaEnrollStep1Response, MfaEnrollStep2Response } from "../../../mfa/hooks/useMfaApi";
import { serviceError } from "./mfaEnrollStep1Errors";

export type MfaStep2ErrorState = "MFA_SERVER_ERROR" | "UNKNOWN";

export const apiErrorContentEmail: ErrorContentMap<MfaStep2ErrorState> = {
    MFA_SERVER_ERROR: serviceError,
    UNKNOWN: serviceError
}

export const apiErrorContentSms: ErrorContentMap<MfaStep2ErrorState> = {
    MFA_SERVER_ERROR: serviceError,
    UNKNOWN: serviceError
}

export const apiErrorContentVoice: ErrorContentMap<MfaStep2ErrorState> = {
    MFA_SERVER_ERROR: serviceError,
    UNKNOWN: serviceError
}

const invalidFieldMessages: InvalidFieldMessages<"field"> = { // No validation alerts for this step, so this isn't actually used
    field: {
        linkText: 'none',
        messages: {empty: 'none'}
    }
}

export const step2ErrFnsEmail = new ErrorContentGenerator<MfaStepProps, MfaFields, MfaStep2ErrorState>({
    apiErrorContent: apiErrorContentEmail,
    invalidFieldHeader: "none", // No validation alerts for this step, so this isn't actually used
    getRefMap,
    getErrState,
    invalidFieldMessages,
    getApiInvalidFields: () => [],
    isIntermediateStep: false
});

export const step2ErrFnsSms = new ErrorContentGenerator<MfaStepProps, MfaFields, MfaStep2ErrorState>({
    apiErrorContent: apiErrorContentSms,
    invalidFieldHeader: "none", // No validation alerts for this step, so this isn't actually used
    getRefMap,
    getErrState,
    invalidFieldMessages,
    getApiInvalidFields: () => [],
    isIntermediateStep: false
});

export const step2ErrFnsVoice = new ErrorContentGenerator<MfaStepProps, MfaFields, MfaStep2ErrorState>({
    apiErrorContent: apiErrorContentVoice,
    invalidFieldHeader: "none", // No validation alerts for this step, so this isn't actually used
    getRefMap,
    getErrState,
    invalidFieldMessages,
    getApiInvalidFields: () => [],
    isIntermediateStep: false
});

function getRefMap(props: MfaStepProps) {
    return {
        field: props.fieldRef
    }
}

function getErrState(apiResponse: AxiosResponse<MfaEnrollStep1Response | MfaEnrollStep2Response> | null) {
    if (!apiResponse || !apiResponse.data.errors || apiResponse.data.code === 400 || apiResponse.data.code === 401) {
        return null;
    }
    if (apiResponse.data.code === 500) {
        return "MFA_SERVER_ERROR";
    } else {
        return 'UNKNOWN';
    }
}